<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import { SeasonPageElementMixin } from "%/dynamic-component-editor/standard-pages/season-page/season-page-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "SeasonCoverImage",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Season Image",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "season",
  },
  mixins: [FallbackImageElementMixin, SeasonPageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.image;
    },
  },
};
</script>

